var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleHalf = function SvgIconCircleHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.922 20.707a1 1 0 0 0 .152-.088A10 10 0 0 0 22 12c0-3.67-1.978-6.88-4.925-8.619a1 1 0 0 0-.154-.088A9.95 9.95 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c1.79 0 3.47-.47 4.922-1.293M15.5 19.196a8 8 0 0 1-2.5.742V4.062c.886.11 1.728.366 2.5.742zm2-13.006A7.98 7.98 0 0 1 20 12c0 2.288-.96 4.351-2.5 5.81zM4 12a8 8 0 0 1 7-7.938v15.876A8 8 0 0 1 4 12",
    clipRule: "evenodd"
  })));
};
export default SvgIconCircleHalf;